import MojitoCore from 'mojito/core';
import SettingsMenuClassic from './classic/index.js';
import SettingsMenuAvantgarde from './avantgarde/index.js';

const UIViewFamily = MojitoCore.Presentation.UIViewFamily;

/**
 * Settings menu. Renders
 * {@link Mojito.Modules.SettingsMenuClassic|SettingsMenuClassic} or
 * {@link Mojito.Modules.SettingsMenuAvantgarde|SettingsMenuAvantgarde} depending on the active
 * design style.
 *
 * @class SettingsMenu
 * @memberof Mojito.Modules
 */
export default UIViewFamily('SettingsMenu', {
    classic: SettingsMenuClassic,
    avantgarde: SettingsMenuAvantgarde,
});
